import {
  MobileFieldSelect,
  type OptionProps,
} from '@sbercloud/uikit-product-mobile-fields';

import { type CategoryListProps } from '../CategoryList';

const PLACEHOLDER = 'Категория';

export function MobileCategorySelect({
  categories,
  value,
  singleMode,
  onChange,
  onOpenChange,
}: CategoryListProps) {
  const options: OptionProps[] = categories.map(({ slug, title }) => ({
    value: slug,
    option: title,
  }));

  const handleChange = (value: string) => {
    onChange(value);
  };

  const handleOpenChange = (value: boolean) => {
    onOpenChange && onOpenChange(value);
  };

  return (
    <MobileFieldSelect
      size="l"
      placeholder={PLACEHOLDER}
      options={options}
      showClearButton={!singleMode}
      selection="single"
      value={value}
      onChange={handleChange}
      onOpenChange={handleOpenChange}
    />
  );
}
